import { DynamicPricingSurchargeEstimateParams } from '~/components/LERE/types';

export const dynamicPricingSurchargeEstimatesQueryKeys = {
  all: ['lere', 'dynamic-pricing-surcharge-estimates'] as const,
  details: () => [...dynamicPricingSurchargeEstimatesQueryKeys.all, 'detail'] as const,
  detail: (params: DynamicPricingSurchargeEstimateParams | undefined, requestVersion = 0) =>
    [...dynamicPricingSurchargeEstimatesQueryKeys.details(), params, requestVersion] as const,
};
